import './polyfills';
import {
  beamerProductId,
  beamerSelector,
  currentCodeVersion,
  sentryEnvironment,
  shouldSentry,
} from './constants/config';
import { checkStatus } from './lib/apiHelpers';
import { initSentry } from './logging/sentry';
import { throwError, throwInfo } from './redux/modules/messages/actions';
import { alertNetworkOutage } from './redux/modules/ui/actions';

export default store => {
  // Sentry Initialization
  if (shouldSentry) {
    const sentry = initSentry();
    window.Sentry = sentry;

    if (sentryEnvironment?.includes(':prod')) {
      // initCSPReportingObserver(sentry)?.observe();
    }
  }

  // https://www.getbeamer.com/docs
  window.beamer_config = {
    button: false,
    product_id: beamerProductId,
    selector: beamerSelector,
    counter: false,
    lazy: true,
  };

  // New version check
  setInterval(() => {
    fetch(`/code_version.json`)
      .then(checkStatus)
      .then(r => r.json())
      .then(({ code_version: latestCodeVersion }) => {
        if (currentCodeVersion !== latestCodeVersion) {
          store.dispatch(
            throwInfo('newVersion', undefined, {
              isRefreshAction: true,
              isPersistent: true,
            })
          );
        }
      })
      .catch(() => {
        store.dispatch(throwError('clientError'));
      });
  }, 300000);

  // Network stability check
  let isOnline = true;
  setInterval(() => {
    if (isOnline && !window.navigator.onLine) {
      store.dispatch(alertNetworkOutage());
    }
    if (!isOnline && window.navigator.onLine) {
      window.location.reload();
    }
    isOnline = window.navigator.onLine;
  }, 1000);
};
